// src/pages/Memories.jsx
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { supabase } from '../lib/supabase';
import MemoryUpload from '../components/MemoryUpload';
import MemoryCard from '../components/MemoryCard';
import { useAuth } from '../context/AuthContext';
import './Memories.css';

function Memories() {
  const { t } = useTranslation();
  const [memories, setMemories] = useState([]);
  const { user, isAdmin } = useAuth();

  const fetchMemories = async () => {
    const { data, error } = await supabase
      .from('memories')
      .select('*')
      .order('created_at', { ascending: false });

    if (!error) setMemories(data);
  };

  useEffect(() => {
    fetchMemories();
  }, []);

  return (
    <div className="memory-page">
      <div className="memory-header">
        <span className="memory-kicker">{t('memories.kicker')}</span>
        <h1 className="memory-title">{t('memories.title')}</h1>
        <div className="memory-rule" />
      </div>
      {isAdmin && (
        <div className="upload-container">
          <MemoryUpload onUpload={fetchMemories} />
        </div>
      )}

      {user && !isAdmin && (
<p className="upload-disabled-message">⚠️ {t('memories.uploadOnly')}</p>
      )}

      <div className="memory-grid">
        {memories.map((m) => (
          <MemoryCard key={m.id} memory={m} />
        ))}
      </div>
    </div>
  );
}

export default Memories;
